<template>
  <div class="content campaigns-wrap">
    <div class="page-header" :class="{'header-hidden': !isScrollTop}">

      <div class="flex px-4 md:block">
        <div class="w-72 lg:w-60 px-4 pt-4 md:hidden">
          <img :src="require('./board.svg')" width="210px"/>
        </div>

        <div class="mt-6 lg:mt-4">
          <div class="font-semibold text-3xl md:text-xl">Donation Campaigns</div>
          <p class="md:hidden">Create fundraising campaigns & goals for donors to designate their donations to!</p>
          <div v-if="campaignsLastUpdate" class="flex justify-between mt-6 lg:mt-3">
            <div class="text-center">
              <span class="font-black text-4xl md:text-xl">{{ allCampaigns.length }}</span>
              <div class="md:text-sm mt-2">Total Campaigns</div>
            </div>
            <div class="text-center px-3">
              <span class="font-black text-4xl md:text-xl">{{ totalDonors }}</span>
              <div class="md:text-sm mt-2">Total Donors</div>
            </div>
            <div class="text-center">
              <span class="font-black text-4xl md:text-xl">${{ (totalAmountRaised / 100) | formatMoney}}</span>
              <div class="md:text-sm mt-2">Total Amount Raised</div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="flex justify-between md:items-center md:flex-col-reverse bg-white shadow-sm px-8 py-3 lg:px-4">
      <div>
        <el-dropdown trigger="click" @command="updateSorting">
          <el-button size="medium"><b>{{ selectedSorting.title }}</b>
            <font-awesome-icon class="ml-4 text-xs text-gray-400" :icon="['far', 'chevron-down']"/>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="item in sortOptions"
                              :key="item.key"
                              :command="item">{{ item.title }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <div class="flex-grow md:mb-4 text-right mr-4 lg:mr-2 md:mr-0">
        <el-radio-group v-model="selectedFilter" size="medium">
          <el-radio-button label="ongoing">Active</el-radio-button>
          <el-radio-button label="ended">Ended</el-radio-button>
          <el-radio-button label="archived">Archived</el-radio-button>
          <el-radio-button label="all">All</el-radio-button>
        </el-radio-group>
      </div>

      <div class="md:mb-4 sm:w-full">
        <div class="inline-block sm:w-4/5">
          <el-input
              size="medium"
              placeholder="Search"
              class="max-w-xs"
              v-model="campaignSearch">
            <i slot="suffix" class="el-input__icon el-icon-search"></i>
          </el-input>

        </div>
        <el-dropdown class="ml-4 lg:ml-2" trigger="click" @command="handleCommand">
          <el-button type="primary" size="medium">
            <font-awesome-icon class="mr-2 lg:mr-0 text-xs leading-2"
                               :icon="['fas', 'plus']"/>
            <span class="lg:hidden">Add New</span>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="['add-category']">
              <font-awesome-icon class="mr-2" :icon="['far', 'folder-plus']"/>
              Add Category
            </el-dropdown-item>
            <el-dropdown-item :command="['edit-categories']">
              <font-awesome-icon class="mr-2" :icon="['far', 'pencil-alt']"/>
              Edit&nbsp;Categories
            </el-dropdown-item>
            <el-dropdown-item :command="['add-campaign']">
              <font-awesome-icon class="mr-2" :icon="['far', 'plus']"/>
              Add Campaign
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

    </div>


    <transition-group name="cmp-list"
                      tag="div"
                      v-if="campaignsLastUpdate"
                      class="list-campaigns"
                      :class="{'list-campaigns-open': isScrollTop}">

      <div v-if="allCampaigns.length<1"
           key="no-campaigns"
           class="empty-placeholder">
        <img :src="require('../../assets/paceholders/36.svg')" alt="No results">
        <h3>No Campaigns Yet</h3>
      </div>

      <div class="list-mode-item"
           v-for="campaign in filteredCampaigns"
           :key="campaign.id"
      >
        <div class="l-m-thumbnail"
             :class="{'thumbnail-archived': campaign && campaign.deletedAt,
             'thumbnail-ended': campaign && campaign.isEnded}"
             v-on:click.prevent="(campaign && campaign.deletedAt) ? unrchiveCampaign(campaign) : ((campaign && campaign.isEnded) ? $router.push({name: 'campaignEdit', params: {campaignId: campaign.id}}) : false)"
        >
          <div v-if="campaign && campaign.deletedAt" class="archived-label archived-label-center">Unarchive</div>
          <div v-else-if="campaign && campaign.isEnded"
               class="archived-label"
          >Ended on {{campaign.endsAt | dateFormat("MMM DD @ h:mmA")}} {{timezone()}}
          </div>

          <router-link :to="{name: 'campaign', params: {campaignId: campaign.id}}">
            <img v-if="campaign.image" :src="campaign.image" :alt="campaign.name">
            <img v-else-if="activeCharityInfo && activeCharityInfo.cover_photo" :src="activeCharityInfo.cover_photo" :alt="campaign.name">
          </router-link>
        </div>
        <div class="l-m-body">
          <h2 class="h2 fw-600">
            <router-link :to="{name: 'campaign',  params: {campaignId: campaign.id}}">{{campaign.name}}</router-link>
          </h2>
          <div v-if="campaign.progress">
            <cmp-progress :campaign="campaign"></cmp-progress>

            <div class="statistics">
              <div>${{(campaign.progress.donated / 100) | formatMoney}}<span class="caption">Total Donated</span></div>
              <div>{{campaign.progress.donors}}<span class="caption">Donors</span></div>

              <el-dropdown v-if="campaign" trigger="click" @command="handleCommand">
                <el-button type="primary" size="medium">Options</el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="['edit', campaign]">Edit</el-dropdown-item>
                  <el-dropdown-item :command="['duplicate', campaign]">Duplicate</el-dropdown-item>
                  <el-dropdown-item v-if="campaign.deletedAt"
                                    :command="['unarchive', campaign]">Unarchive</el-dropdown-item>
                  <el-dropdown-item v-else :command="['archive', campaign]">Archive</el-dropdown-item>
                  <el-dropdown-item :command="['view-details', campaign]">View Details</el-dropdown-item>
                  <el-dropdown-item v-if="activeCharityInfo"
                                    :command="['campaign-page', campaign]">Campaign Page</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
    </transition-group>

    <archive-campaign-modal :visible.sync="isArchiveModal"
                            :activeCampaignId="activeCampaignId"
    ></archive-campaign-modal>

    <CreateCategoryModal :visible.sync="isCreateCategoryModal"
                         v-on:done="isCreateCategoryModal = false;refreshCategories()"
    ></CreateCategoryModal>

    <CreateCategoryModal v-if="editCategoryInfo"
                         :visible.sync="isEditOneCategoryModal"
                         v-on:done="isEditOneCategoryModal = false;refreshCategories()"
                         :edit-category-info="editCategoryInfo"
    ></CreateCategoryModal>

    <modal v-if="isEditCategoryModal && allCategories.length"
           v-on:close-modal="isEditCategoryModal = false"
           v-on:done="isEditCategoryModal = false"
           :categories="allCategories"
           v-on:edit-category="editCategory"
           v-on:refresh="refreshCategories"
           :modal-name="'edit-category-modal'"></modal>

  </div>
</template>

<script>
  import {editCampaign, getAllCategories} from '@/utils/api';
  import CmpProgress from './progress.vue';
  import scrollInfoMixin from '../../mixins/scroll-info-mixin';
  import config from '../../../public/harness_config.json';
  import CreateCategoryModal from './create-category-modal';
  import ArchiveCampaignModal from './archive-campaign-modal';
  import Modal from '../Modal/index.vue';
  import {mapState} from "vuex";

  const moment = require('moment-timezone');

  export default {
    name: 'Campaigns',
    metaInfo: {
      title: 'Campaigns',
    },
    mounted() {
      this.updateCampaigns();
    },
    mixins: [scrollInfoMixin],
    components: {
      CmpProgress,
      Modal,
      CreateCategoryModal,
      ArchiveCampaignModal
    },
    methods: {
      handleCommand([command, payload]) {
        switch (command){
          case 'add-category':
            this.isCreateCategoryModal = true;
            break
          case 'edit-categories':
            this.isEditCategoryModal = true;
            break
          case 'add-campaign':
            this.$router.push('add-campaign');
            break
          case 'edit':
            this.$router.push({name: 'campaignEdit', params: {'campaignId': payload.id}});
            break
          case 'duplicate':
            this.$router.push({name: 'campaignAdd', query: {'clone-id': payload.id}});
            break
          case 'unarchive':
            this.unrchiveCampaign(payload);
            break
          case 'archive':
            this.isArchiveModal = true; this.activeCampaignId = payload.id;
            break
          case 'view-details':
            this.$router.push({name: 'campaign', params: {'campaignId': payload.id}});
            break
          case 'campaign-page':
            window.open(`${this.config.donor_next_scheme}://${this.activeCharityInfo.subdomain}.${this.config.donor_next_url}/campaigns/${payload.id}`);
            break
        }
      },
      updateSorting(newSorting){
        this.selectedSorting = newSorting;
      },
      timezone(){
        const zone_name =  moment.tz.guess();
        return moment.tz(zone_name).zoneAbbr();
      },
      editCategory(category){
        this.isEditCategoryModal = false;
        this.editCategoryInfo = category;

        this.$nextTick(() => {
          this.isEditOneCategoryModal = true;
        });
      },
      unrchiveCampaign(campaign) {
        editCampaign(
          campaign.id,
          campaign.name,
          campaign.description,
          campaign.image,
          campaign.goal ? campaign.goal : '',
          true
        ).then(() => {
          this.$message('Campaign Unarchived');
          this.$store.dispatch('campaigns/updateCampaigns', {charity_id: this.activeCharityId, force: true});
        });
      },
      refreshCategories(){
        getAllCategories().then(categories => {
          this.allCategories = categories;
          this.categoriesIsLoaded = true;
        });
      },
      updateCampaigns() {
        this.allCategories = [];
        this.categoriesIsLoaded = false;

        this.refreshCategories();

        this.$store.dispatch('campaigns/updateCampaigns', {charity_id: this.activeCharityId, force: true}).then(() => {
          this.$nextTick(() => {
            this.initScrollInfo(['.list-campaigns']);
          });

        });
      },
      completePercent(campaign) {
        return Math.round(parseFloat(campaign.progress.donated / 100) / parseFloat(campaign.goal / 100) * 100);
      },
      sortCampaigns(campaigns, type){
        switch (type) {
          case "total_donated":
            return [...campaigns].sort((cmp1, cmp2) => {
              let val1 = cmp1.progress && Number(cmp1.progress.donated) || 0;
              let val2 = cmp2.progress && Number(cmp2.progress.donated) || 0;

              return val2 - val1;
            });
          case "percent_complete":
            return [...campaigns].sort((cmp1, cmp2) => {
              let val1 = cmp1.progress && Number(cmp1.progress.donated) || 0;
              let val2 = cmp2.progress && Number(cmp2.progress.donated) || 0;
              if (cmp1.progress && cmp1.goal) {
                val1 = this.completePercent(cmp1) + 10000000000
              }
              if (cmp2.progress && cmp2.goal) {
                val2 = this.completePercent(cmp2) + 10000000000
              }
              return val2 - val1;
            });
          case "donors":
            return [...campaigns].sort((cmp1, cmp2) => {

              let val1 = cmp1.progress && Number(cmp1.progress.donors) || 0;
              let val2 = cmp2.progress && Number(cmp2.progress.donors) || 0;

              return val2 - val1;
            });

          case "goal_amount":
            return [...campaigns].sort((cmp1, cmp2) => (Number(cmp2.goal) || 0) - (Number(cmp1.goal) || 0));

          case "alphabetical":
            return [...campaigns].sort((cmp1, cmp2) => cmp1.name.localeCompare(cmp2.name));

          case "date_created":
          default:
            return [...campaigns].sort((cmp1, cmp2) => {
              return (new Date(cmp2.createdAt)).valueOf() - (new Date(cmp1.createdAt)).valueOf();
            });
        }
      }
    },
    computed: {
      ...mapState({
        activeCharityId: state => state.auth.activeCharityId,
        activeCharityInfo: state => state.charities.activeCharityInfo,
        allCampaigns: state => state.campaigns.allCampaigns,
        campaignsLastUpdate: state => state.campaigns.lastUpdate,
      }),
      totalDonors() {
        return this.allCampaigns.reduce((res, campaign) => {
          return (campaign && campaign.progress) ? res + campaign.progress.donors * 1 : res;
        }, 0);
      },
      totalAmountRaised() {
        return this.allCampaigns.reduce((res, campaign) => {
          return (campaign && campaign.progress) ? res + campaign.progress.donated * 1 : res;
        }, 0);
      },
      filteredCampaigns() {
        const nowTime = moment();
        let allCampaigns = this.allCampaigns.map(cmp => (
            {...cmp, isEnded: moment(cmp.endsAt) < nowTime}
        ));

        if (this.campaignSearch !== '') {
          let re = new RegExp(this.campaignSearch, 'ig');
          allCampaigns = allCampaigns.filter(campaign => campaign.name.search(re) !== -1);
        }

        if (this.selectedFilter === 'archived') {
          allCampaigns = allCampaigns.filter(campaign => campaign.deletedAt);
        } else if (this.selectedFilter === 'ongoing') {
          allCampaigns = allCampaigns.filter(campaign => !campaign.deletedAt && !campaign.isEnded);
        } else if (this.selectedFilter === 'ended') {
          allCampaigns = allCampaigns.filter(campaign => campaign.isEnded);
        }
        // else if (this.selectedFilter === 'completed') {
        //   return allCampaigns.filter(campaign => campaign.progress.complete);
        // }

        return this.sortCampaigns(allCampaigns, this.selectedSorting.key);
      },
      config() {
        return config;
      },
    },
    watch: {
      'activeCharityId'() {
        this.updateCampaigns();
      },
    },
    data() {
      return {
        selectedFilter: 'ongoing',
        campaignSearch: '',
        activeCampaignId: null,

        isArchiveModal: false,
        isCreateCategoryModal: false,
        isEditCategoryModal: false,
        isEditOneCategoryModal: false,
        editCategoryInfo: null,

        allCategories: [],
        categoriesIsLoaded: false,

        sortOptions: [
          {key: 'date_created', title: 'Date Created'},
          {key: 'alphabetical', title: 'Alphabetical'},
          {key: 'donors', title: 'Donors'},
          {key: 'goal_amount', title: 'Goal Amount'},
          {key: 'total_donated', title: 'Total Donated'},
          {key: 'percent_complete', title: 'Percent Complete'},
        ],
        selectedSorting: {key: 'date_created', title: 'Date Created'}
      };
    },
  };
</script>
<style lang="scss">
.cmp-list-move {
  transition: transform .5s;
}

</style>
<style lang="sass" scoped>
  .campaigns-wrap
    .select-add-new
      width: 165px
      .icon-wrap
        display: inline-block
        width: 16px
    .donors-panel
      .col-sm-5
        i
          font-style: normal

      .btn-plus
        max-width: 136px
        padding: 9px 10px 8px 26px

      .search
        margin: 0 15px
        font-weight: 600
        font-size: 14px

      ::-webkit-input-placeholder
        color: rgb(53, 64, 82)
        opacity: 0.5
        font-weight: 600
        font-size: 14px
        font-family: var(--main-font-family)

      ::-moz-placeholder
        color: rgb(53, 64, 82)
        opacity: 0.5
        font-weight: 600
        font-size: 14px
        font-family: var(--main-font-family)

      -ms-input-placeholder
        color: rgb(53, 64, 82)
        opacity: 0.5
        font-weight: 600
        font-size: 14px
        font-family: var(--main-font-family)

    .list-campaigns
      overflow-y: auto
      transition: all .5s ease-in-out

      &.list-campaigns-open
        height: calc(100vh - 324px)

    .list-mode-item
      overflow: visible
      position: relative
      .dropdown
        .btn
          box-shadow: none

      .dropdown-content
        width: 180px
        font-weight: 400

</style>
